/**
 * Locale → ISO-3166-1 alpha-2 country code, for the flag shown beside a
 * language in a picker (F32).
 *
 * ONE map, imported by both language pickers (`LanguageSelector` in the header
 * and `PreferencesSection` in Settings). They previously each carried their own
 * hard-coded emoji map, so the two could — and did — drift.
 *
 * A language is not a country, so this is a display convention, not a fact:
 * `en` shows the UK flag because that is the flag users expect next to
 * "English" in this product's pickers.
 */
import type { SupportedLocale } from '@tonnie/locale';

export const LOCALE_FLAG_COUNTRY: Record<SupportedLocale, string> = {
  en: 'GB',
  'pt-PT': 'PT',
  'pt-BR': 'BR',
  'es-ES': 'ES',
  'it-IT': 'IT',
};
